import Header from './Header.jsx';

export default Header;



// WEBPACK FOOTER //
// ./js/sport-betting/components/header/index.js